import userCounter from "../CoustomHook/userCounter";


function Counter() {
  const [count,increas,decreas,reset]= userCounter(5)
    return (
        <div className='container'>
            <p>Counter</p>
            <p>{count}</p>
            <button type='button' className='btn btn-success' onClick={increas} >+</button>
            <button  type='button' className='btn btn-warning' onClick={reset}>0</button>
            <button  type='button' className='btn btn-danger' onClick={decreas}>-</button>
        </div>
    )
}

export default Counter
